import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { Switch } from 'react-router-dom';
import Collapse from 'src/components/Collapse';
import Header from 'src/components/Header';
import RouteFallback from 'src/components/RouteFallback';

import { NormalConfig } from '../../routes';
import RouteWithSubRoutes from '../../utils/route';
import NavConfig from './../../conf/collapse';

const initialState = {
  showNav: false,
  showLogin: false,
  showHeader: false
};
type IState = Readonly<typeof initialState>;


class NormalLayout extends React.Component<RouteComponentProps, IState> {
  public readonly state = initialState;
  public async componentDidMount() {
    this.closeHeader()
  }

  public closeHeader = () => {
    this.setState({
      showHeader: this.props.history.location.pathname.includes('/normal/query/detail') || this.props.history.location.pathname.includes('/normal/query/newdetail')
    })
  }

  public toggleLogin = () => {
    this.setState({
      showNav: false
    });
  };
  public toggleNav = (flag?: boolean) => {
    this.setState({
      showNav: flag !== undefined ? flag : !this.state.showNav
    });
  };
  public render() {
    console.log(this.state.showHeader)
    return (
      <div>
        {!this.state.showHeader &&
          <Header
            show={this.state.showNav}
            handleShowNav={this.toggleNav}
            handleShowLogin={() => ''}
            history={this.props.history}
          />
        }
        <Collapse
          height='0.8'
          data={NavConfig}
          show={this.state.showNav}
          handleShowNav={this.toggleNav}
          history={this.props.history}
        />
        <Switch>
          {NormalConfig.map((route: any, index: number) => {
            return <RouteWithSubRoutes key={index} {...route} history={this.props.history} />;
          })}
          <Route component={RouteFallback} />
        </Switch>
      </div>
    );
  }
}

export default NormalLayout;



// WEBPACK FOOTER //
// ./src/layouts/NormalLayout/index.tsx